import {useEffect, useState} from "react";

import Grid from '@mui/material/Grid2'

import TableViewIcon from '@mui/icons-material/TableView';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
// import SsidChartIcon from '@mui/icons-material/SsidChart';
import PieChartIcon from '@mui/icons-material/PieChart';

import { BreadCrumbsCustom } from "../../../components/BreadCrumbsCustom";
import DashboardBody from "../DashboardMain/DashboardBody";
import IndexPie from "./GraphicPie/IndexPie";
import IndexBar from "./GraphicBar/IndexBar";
import IndexTable from "./GraphicTable/IndexTable";


////SI PORTA DIETRO SITE(brand, id, name) E VARIABLELIST[{variable, color}]
/// FA UNA CHIAMATA({chartDataResponse,isLoading}, triggerRequest)
///RISTRUTTURA VARIBLESLIST INSERENDOLO IN VARIABLES PER INSERIRCI VARIABLE E COLOR
///SEARCH è UNA FUNZIONE PER SETTARE DATA IN BASE ALLE DATE ED I SELEZIONATI
////QUESTO COMPONENTE E' L'UNIONE DI 4 COMPONENTI:EnergyChart(il grafico), 
///AccordionWrapper(le variabili da selezionare), DashboardFooter(il footer), 
///PeriodPicker(un Dialog che è una specie di modale, per selezionare il periodo da visualizzare)

export default function Energy(props) {
  const {RouterLink, SITES_ROUTE, SITE_ROUTE, data} = props;

  const [switchCase, setSwitchCase] = useState("0");
  
  ///useEffect per pulire il localStorage quando si aggiorna la pagina
  useEffect(() => {
    const clearLocalStorage = () => {
      sessionStorage.removeItem('reportFromDate');
      sessionStorage.removeItem('reportToDate');
      sessionStorage.removeItem('selectedFrequency');
      sessionStorage.removeItem('checkedVariables');
      sessionStorage.removeItem('selectedPeriod');
    };
    window.addEventListener('beforeunload', clearLocalStorage);

    return () => {
      window.removeEventListener('beforeunload', clearLocalStorage);
    };
  }, []);
  
  ////RENDER DEL GRAFICO IN BASE AL PULSANTE PREMUTO DETERMIATO DALL'ID SWITCHCASE
  const renderContent = () => {
    switch (switchCase) {
      case "0":
        return <IndexBar {...props}/>; 
      case "1":
        return <IndexTable {...props}/>; 
      case "2":
        return <IndexPie {...props}/>;
      // case "3":
      //   return ; 
      default:
        return null; 
    }
  };

  ///DETERMINA GLI ID E LE ICONE DELLA BARRA STACK
  const configStack = [
    {value:"0", title:"Grafico a barre",icon:<StackedBarChartIcon/>},
    {value:"1",title:"Tabella dati", icon:<TableViewIcon/>},
    {value:"2",title:"Grafico a torta", icon:<PieChartIcon/>},
    // {value:"3",title:"Grafico a linee", icon:<SsidChartIcon />},
  ]

  const configBradCrumbs = {
    Component:BreadCrumbsCustom,
    generalConfig:{
      RouterLink:RouterLink,
      typographyText:data.category.name,
      linkConfig:[
        {
          to:SITES_ROUTE.path,
          textLink:"Home",
        },
        {
          to:SITE_ROUTE.computePath({siteId: data.site.id}),
          textLink:data.site.brand + " - " + data.site.name,
        },
      ]
    },
  }

  const propsDashboardBody = {configBradCrumbs, configStack, switchCase, setSwitchCase}

  return (
    <DashboardBody {...propsDashboardBody}>
      <Grid item size={12}>
        {renderContent()}
      </Grid>
    </DashboardBody>
  );
}


